import React, { Component } from "react";
import { connect } from "react-redux";
import { dialogActions } from "../constants";
import { executeDialogAction } from "../../actions";
import { ConfirmationDialog } from "../components";

const {
   COMMON_ACTIONS: { CONFIRMATION_DIALOG, CLOSE_DIALOG, CONFIRM_DIALOG },
} = dialogActions;

class DialogsManagement extends Component {
   handleClose = () => {
      const { executeDialogAction } = this.props;
      executeDialogAction({ action: CLOSE_DIALOG });
   };

   handleConfirm = () => {
      const { executeDialogAction } = this.props;
      executeDialogAction({ action: CONFIRM_DIALOG });
   };

   render() {
      const { dialogAction } = this.props;

      switch (dialogAction.action) {
         case CONFIRMATION_DIALOG:
            return (
               <ConfirmationDialog
                  data={dialogAction.data}
                  handleClose={this.handleClose}
                  handleConfirm={this.handleConfirm}
               />
            );

         default:
            return null;
      }
   }
}

const mapStateToProps = ({ shared: { dialogAction } }) => ({
   dialogAction,
});

const mapDispatchToProps = {
   executeDialogAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(DialogsManagement);